module.exports = __webpack_public_path__ + "img/question.201a07c9.svg";